/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gross_Seemly_Capybara_PeelInputs */

const fr_gross_seemly_capybara_peel = /** @type {(inputs: Gross_Seemly_Capybara_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun programme personnel`)
};

/**

* @param {Gross_Seemly_Capybara_PeelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const gross_seemly_capybara_peel = /** @type {((inputs?: Gross_Seemly_Capybara_PeelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gross_Seemly_Capybara_PeelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_gross_seemly_capybara_peel(inputs)
});